/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 03.11.25
 *
 */
export const ServiceUsageType = Object.freeze({
	QUANTITY: 'QUANTITY',
	QUANTITY_NUMBER: 'QUANTITY_NUMBER',
	PRICE: 'PRICE',
	RATE: 'RATE',
})
